import { render, staticRenderFns } from "./CoTwoPostProductionActivitiesForm.vue?vue&type=template&id=253daf1b&"
import script from "./CoTwoPostProductionActivitiesForm.vue?vue&type=script&lang=js&"
export * from "./CoTwoPostProductionActivitiesForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('253daf1b')) {
      api.createRecord('253daf1b', component.options)
    } else {
      api.reload('253daf1b', component.options)
    }
    module.hot.accept("./CoTwoPostProductionActivitiesForm.vue?vue&type=template&id=253daf1b&", function () {
      api.rerender('253daf1b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/carbonclap/components/green/form/CoTwoPostProductionActivitiesForm.vue"
export default component.exports